// File: idle-timeout.service.ts
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SessionWarningDialogComponent } from '../session-warning-dialog/session-warning-dialog.component';
import { AdminAuthService } from './admin-auth.service';

@Injectable({ providedIn: 'root' })
export class IdleTimeoutService {
  private logoutTimeout: any;
  private warningTimeout: any;

  private readonly IDLE_TIMEOUT = 30 * 60 * 1000;
  private readonly WARNING_OFFSET = 5 * 60 * 1000;

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private dialog: MatDialog,
    private authService: AdminAuthService
  ) { }

  startWatching(): void {
    this.resetTimeouts();

    ['mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event =>
      window.addEventListener(event, this.resetTimeouts.bind(this))
    );
  }

  private resetTimeouts(): void {
    clearTimeout(this.logoutTimeout);
    clearTimeout(this.warningTimeout);

    this.ngZone.runOutsideAngular(() => {

      this.logoutTimeout = setTimeout(() => {
        this.ngZone.run(() => {
          this.router.navigate(['/admin/logout']);
        });
      }, this.IDLE_TIMEOUT);

      this.warningTimeout = setTimeout(() => {
        this.ngZone.run(() => this.openWarningDialog());
      }, this.IDLE_TIMEOUT - this.WARNING_OFFSET);
    });
  }

  private openWarningDialog(): void {
    if (!this.authService.isLoggedIn()) {
      this.stopWatching();
      return;
    }

    const warningSeconds = (this.IDLE_TIMEOUT - this.WARNING_OFFSET) / 1000;

    const dialogRef = this.dialog.open(SessionWarningDialogComponent, {
      width: '400px',
      disableClose: true,
      data: { countdownSeconds: warningSeconds }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'stay') {
        this.resetTimeouts();
      } else {
        this.router.navigate(['/admin/logout']);
      }
    });
  }

  stopWatching(): void {
    clearTimeout(this.logoutTimeout);
    clearTimeout(this.warningTimeout);

    ['mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event =>
      window.removeEventListener(event, this.resetTimeouts.bind(this))
    );
  }
}
